module.exports = __webpack_public_path__ + "img/ic_menu.e394799e.svg";